import type { AgentId } from '../../types/anna';
import type { DeskMoment, DiffFile, LiveLog, Render, SlackMessage } from '../../types/db';

/** What the agents stream onto the desk stage while nothing is summoned. Test counts add up to PR #142 (48). */
export const liveLogs: LiveLog[] = [
  {
    agent: 'code',
    lines: [
      { text: '$ pnpm test --filter project-x' },
      { text: 'PASS  src/api/client.test.ts', tests: 12 },
      { text: 'PASS  src/api/retry.test.ts', tests: 6 },
      { text: 'PASS  src/auth/session.test.ts', tests: 9 },
      { text: 'PASS  src/billing/invoice.test.ts', tests: 8 },
      { text: 'PASS  src/ui/form.test.tsx', tests: 7 },
      { text: 'PASS  src/utils/date.test.ts', tests: 6 },
      { text: 'Tests: 48 geslaagd, 0 gefaald' },
      { text: '$ git push origin fix/nachtelijke-build' },
      { text: 'PR #142 bijgewerkt, wacht op jouw review' },
    ],
  },
];

export const diffs: DiffFile[] = [
  {
    prId: 'pr-142',
    path: 'src/api/client.ts',
    hunk: '@@ -18,12 +18,20 @@ export function createClient',
    lines: [
      { type: 'ctx', n: 18, text: 'export function createClient(options: ClientOptions) {' },
      { type: 'del', n: 19, text: '  const agent = new Agent({ keepAlive: true });' },
      { type: 'add', n: 19, text: '  const dispatcher = new Agent({' },
      { type: 'add', n: 20, text: '    keepAliveTimeout: options.keepAlive ?? 10_000,' },
      { type: 'add', n: 21, text: '  });' },
      { type: 'ctx', n: 22, text: '  return {' },
      { type: 'del', n: 23, text: '    request: (path) => fetch(url(path), { agent }),' },
      { type: 'add', n: 23, text: '    request: (path) => fetch(url(path), { dispatcher }),' },
      { type: 'ctx', n: 24, text: '  };' },
    ],
  },
  {
    prId: 'pr-142',
    path: 'src/api/client.test.ts',
    hunk: '@@ -40,6 +40,12 @@ describe("createClient"',
    lines: [
      { type: 'ctx', n: 40, text: '  it("hergebruikt verbindingen", async () => {' },
      { type: 'del', n: 41, text: '    expect(client.agent).toBeDefined();' },
      { type: 'add', n: 41, text: '    const res = await client.request("/health");' },
      { type: 'add', n: 42, text: '    expect(res.ok).toBe(true);' },
      { type: 'ctx', n: 43, text: '  });' },
    ],
  },
  {
    prId: 'pr-142',
    path: 'package.json',
    hunk: '@@ -21,7 +21,8 @@',
    lines: [
      { type: 'del', n: 22, text: '    "http-client": "^4.2.0",' },
      { type: 'add', n: 22, text: '    "http-client": "^5.0.1",' },
      { type: 'add', n: 23, text: '    "undici": "^6.19.0",' },
    ],
  },
];

export const slackMessages: SlackMessage[] = [
  {
    id: 's-bakker',
    channel: '#project-x',
    contactId: 'bakker',
    time: '09:47',
    text: 'Gaat de fix voor de build vandaag nog live? We willen morgen de demo geven.',
    toYou: true,
    draftReply: 'De fix staat klaar in PR #142, alle tests zijn groen. Ik merge vandaag na de review, dus morgen kun je de demo geven.',
    status: 'open',
  },
];

export const renders: Render[] = [
  {
    id: 'render-landing',
    title: 'Beeld voor de nieuwe landingspagina',
    prompt: 'Rustig architectonisch interieur in de schemering, betonnen bogen, zacht teal licht, één warme lichtbron, geen tekst.',
    model: 'FLUX.1 dev',
    where: 'lokaal',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/91df605c-b142-41cf-ad88-c38c68fd7a1b.jpg',
    status: 'bezig',
    seconds: 64,
  },
];

export const deskMoments: DeskMoment[] = [
  { id: 'start', time: '09:40', title: 'Aan het werk' },
  {
    id: 'diff',
    time: '09:41',
    title: 'Diff tonen',
    owner: 'Laat de diff van de build-fix zien.',
    anna: 'Hier is de fix: drie bestanden, alle 48 tests geslaagd. Mergen doe je zelf.',
    panel: 'diff',
  },
  {
    id: 'slack',
    time: '09:48',
    title: 'Slack-vraag',
    anna: 'Klant Bakker vraagt in #project-x of de fix vandaag live gaat. Zal ik een antwoord voorbereiden?',
    panel: 'slack',
    effect: 'slackPulse',
  },
  {
    id: 'render',
    time: '10:05',
    title: 'Render klaar',
    anna: 'Het beeld voor de landingspagina is klaar.',
    panel: 'render',
    effect: 'finishRender',
  },
  {
    id: 'budget',
    time: '15:20',
    title: 'Cloudbudget 80%',
    anna: 'Je zit op 80% van je cloudbudget. Ik schakel voor de rest van de dag over op lokale modellen.',
    panel: 'kosten',
    effect: 'overBudget',
  },
];

export const deskSuggestions: string[] = [
  'Laat de diff van de build-fix zien',
  'Wat vraagt Slack?',
  'Toon het concept voor Bakker',
  'Wat kost de cloud vandaag?',
  'Bereid de meeting met Lisa voor',
];

export const cloudCostByAgent: { agent: AgentId; euro: number }[] = [
  { agent: 'mail', euro: 0.92 },
  { agent: 'initiatief', euro: 0.41 },
  { agent: 'code', euro: 0.31 },
  { agent: 'slack', euro: 0.2 },
];
